export type Action = () => void;

export type Producer<O> = () => O;

export type Consumer<I> = (arg0: I) => void;

export type DoubleConsumer<A, B> = (arg0: A, arg1?: B) => void;

export type Func<I, O> = (arg0: I) => O;

export type Predicate<I> = (arg0: I) => boolean;

export type Comparator<A, B> = (arg0: A, arg1: B) => boolean;

export const EmptyAction = () => {};
export const EmptyConsumer = () => {};
export const AlwaysTrue = (i) => true;
export const AlwaysFalse = (i) => false;
